const { h, render, Component } = require('preact');
const Web2018Helper = require('../../../helper')

class CheckOutInfo extends Component {
  constructor(props) {
    super(props);
    this.getCheckOutInfo = this.getCheckOutInfo.bind(this);
  }

  getCheckOutInfo(orderDetails){
    if(orderDetails && orderDetails.travelBookingInfo && orderDetails.travelBookingInfo.reservation && orderDetails.travelBookingInfo.reservation.formattedCheckOutDate)
      return orderDetails.travelBookingInfo.reservation.formattedCheckOutDate;
    else if(orderDetails && orderDetails.groupons && orderDetails.groupons[0] && orderDetails.groupons[0].extraAttributes && orderDetails.groupons[0].extraAttributes.formattedCheckOut)
      return orderDetails.groupons[0].extraAttributes.formattedCheckOut;
    else
      return null;
  }

  render() {
    let checkOutInfo = this.getCheckOutInfo(this.props.orderDetails);
    if (checkOutInfo){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.check_out")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(checkOutInfo)}</td>
        </tr>
      );
    }
    return null;
  }
}
module.exports = CheckOutInfo
